import axios, { AxiosRequestConfig } from 'axios'
import _ from 'lodash'
import { TokenService } from './auth/token.service'
import { UserAuthService } from './auth/auth_user.service'
import { Dictionary } from 'vue-router/types/router'
import { store } from '@/modules/store/store-module'
import { stringify } from 'query-string'
import { router } from '@/modules/router'

const ApiService = {
  /**
     * Base class for using API to comunicate with other services,
     * @param baseURL
     */

  // Stores the 401 interceptor position so that it can be later ejected when needed
  _401interceptor: null,

  config: {},
  instance: null,

  init (baseURL: string) {
    this.instance = axios.create({
      baseURL: baseURL
    })

    this._401interceptor = this.instance.interceptors.response.use(
      (response) => {
        console.info('axios interceptor fulfilled')
        return response
      },
      async (error) => {
        console.info('axios interceptor rejected')
        console.info(error.request)
        if (error.request.status === 401) {
          if (error.config.url.includes('/auth/token/')) {
            // Refresh token has failed. Logout the user
            await store.dispatch('auth/logout')
            throw error
          } else {
            // Refresh the access token
            try {
              console.info('pre refresh token')
              await store.dispatch('auth/refreshToken')
              console.info('after refresh token')

              console.warn(error.config)

              console.info('Log: ' + TokenService.getToken())
              // Retry the original request
              let response = this.instance({
                method: error.config.method,
                url: error.config.url,
                data: error.config.data,
                headers: { 'Authorization': `Bearer ${TokenService.getToken()}` }
              })

              return response
            } catch (e) {
              // Refresh has failed - reject the original request
              await store.dispatch('auth/logout')
              throw error
            }
          }
        }
        // If error was not 401 just reject as is
        throw error
      }
    )
  },

  getHeaders (headers?: Dictionary<string>) {
    if (!headers) {
      headers = {}
    }

    let token = TokenService.getToken()
    if (token) {
      headers['Authorization'] = `Bearer ${TokenService.getToken()}`
    }

    return headers
  },

  _parseQueryParams (query_params?: Dictionary<string> | null): string | null {
    if (query_params) {
      return `?${stringify(query_params)}`
    }
    return ''
  },

  get (resource: string, queryParams?: Dictionary<any> | null, headers?: Dictionary<string>) {
    console.warn(this.instance.headers)
    return this.instance.get(`${resource}${this._parseQueryParams(queryParams)}`,
      { 'headers': this.getHeaders() })
  },

  post (resource: string, data: JSON, queryParams?: Dictionary<any> | null) {
    return this.instance.post(`${resource}${this._parseQueryParams(queryParams)}`, data,
      { 'headers': this.getHeaders() })
  },

  put (resource: string, data: JSON, queryParams?: Dictionary<any> | null) {
    return this.instance.put(`${resource}${this._parseQueryParams(queryParams)}`, data,
      { 'headers': this.getHeaders() })
  },

  patch (resource: string, data: JSON, queryParams?: Dictionary<any> | null) {
    return this.instance.patch(`${resource}${this._parseQueryParams(queryParams)}`, data,
      { 'headers': this.getHeaders() })
  },

  delete (resource: string, data: JSON, queryParams?: Dictionary<any> | null) {
    return this.instance.delete(`${resource}${this._parseQueryParams(queryParams)}`,
      { 'headers': this.getHeaders() })
  },

  customRequest (data: Dictionary<any>) {
    try {
      return this.instance(data)
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data)
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request)
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message)
      }
    }
  },

  mount401Interceptor () {
    console.info(' interceptor')

    this._401interceptor = this.instance.interceptors.response.use(
      (response) => {
        console.info('axios interceptor fulfilled')
        return response
      },
      async (error) => {
        console.info('axios interceptor rejected')
        if (error.request.status === 401 || error.request.status === 500 || error.request.status === 400) {
          if (error.config.url.includes('/auth/token/')) {
            // Refresh token has failed. Logout the user
            await store.dispatch('auth/logout')
            // UserAuthService.logout(true);

            throw error
          } else {
            // Refresh the access token
            try {
              await store.dispatch('auth/refreshToken')

              // Retry the original request
              return axios({
                method: error.config.method,
                url: error.config.url,
                data: error.config.data
              })
            } catch (e) {
              // Refresh has failed - reject the original request
              console.info('error on fetching refresh token')
              throw error
            }
          }
        }
        // If error was not 401 just reject as is
        throw error
      }
    )
    console.info('interceptor instance')
    console.info(this._401interceptor)
  },
  unmount401Interceptor () {
    // Eject the interceptor
    this.instance.interceptors.response.eject(this._401interceptor)
  }
}

export { ApiService }
